import React from 'react';
import { useSelector } from 'umi';
import { PC_PAGE_CONFIG } from './pcPageConfig';
import { MOBILE_PAGE_CONFIG } from './mobilePageConfig';
import { NIGHTINGALE_PAGE_CONFIG } from './nightingalePageConfig';
import CommonPageRender from '@/pages/dashboard/components/PageContainer/CommonPageRender';

import '@/pages/dashboard/assets/scss/page/Overlay/newDaily.scss';
import { IPageConfigType } from '../../components/PageContainer/type';

const reqParams = '/eventAnalysis/eventAnalysis';
interface pageConfigObjProp {
  [key: string]: IPageConfigType
}
const pageConfigObj: pageConfigObjProp = {
  mobile: MOBILE_PAGE_CONFIG,
  pc: PC_PAGE_CONFIG,
  pc_inflexion: NIGHTINGALE_PAGE_CONFIG,
}

const EventAnalysis = () => {
  const dataFrame = useSelector((state: any) => {
    return state?.dashboard?.currentGame?.data_frame || 'mobile'
  });
  return (
    <>
      <CommonPageRender reqParams={reqParams} pageConfigInit={pageConfigObj?.[dataFrame]} />
    </>
  );
};

export default EventAnalysis;